export default __webpack_public_path__ + "59e30ba0cb04505cd25bc0d0cdea4056.png";